import axios from 'axios';

const api = axios.create({
	// baseURL: 'http://localhost:3333',
  // baseURL: 'http://192.168.100.14:3333', // Casa
	// baseURL: 'http://192.168.0.45:3333', // Escritório
	baseURL: 'https://raziobackend.razio.com.br', // Servidor //
});

export default api;
